import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class SuperAdminAuthGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(): boolean {
        const isSuperAdmin = this.checkIfSuperAdmin();

        if (!isSuperAdmin) {
            console.warn('Access denied: User is not super-admin');
            this.router.navigate(['/not-found']);
            return false;
        }

        console.info('Access granted: User is super-admin');
        return true;
    }

    /**
     * Vérifie si l'utilisateur a le rôle "super-admin".
     */
    private checkIfSuperAdmin(): boolean {
        /**
         *Ajout temporaire du rôle 'super-admin' dans le localStorage.
         *Cette configuration est en place jusqu'à l'implémentation d'un service dédié pour gérer les rôles
         */
        localStorage.setItem('userRole', 'super-admin');
        // Récupérer le rôle depuis localStorage
        const userRole = localStorage.getItem('userRole');
        console.log('User role:', userRole); // Debugging

        // Vérifier si le rôle correspond à "super-admin"
        return userRole === 'super-admin';
    }
}
